import './ConsentPage.css';
import SharkHeader from '../components/SharkHeader';

const ConsentPage = () => {
  const handleAllow = () => {
    const redirectURI = sessionStorage.getItem('redirectURI');
    console.log('Redirecting to:', redirectURI.toString());
    window.location.href = redirectURI.toString();
  };

  const handleCancel = () => {
    const queryParams = window.location.search;
    window.location.href = 'https://veita.skegox.com/' + queryParams;
  };

  //   const handleBack = () => {
  //     window.history.back();
  //   };

  return (
    <div className="container">
      {/* <button className="back-button" onClick={handleBack}>←</button> */}
      <SharkHeader />
      <h1 className="title">Connect with Google</h1>
      <div className="card">
        <p className="description">
          By signing in, you are authorizing Google to control your devices.
        </p>
        <p className="policy-link">
          Review{' '}
          <a
            href="http://policies.google.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google's Privacy Policy
          </a>
        </p>
        <div className="buttons">
          <button className="allow" onClick={handleAllow}>Allow</button>
          <button className="cancel" onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ConsentPage;
